/* Belfast Whiskey Week — Venue Map engine.
   Extracted verbatim from the inline <script> in sections/map.liquid so the
   static code is cacheable; all Liquid-derived data/settings arrive via the
   #bww-map-config JSON island rendered by that section. Loaded with `defer`
   after leaflet.js + leaflet.markercluster.js (defer preserves order), with
   waitForLeaflet() as a belt-and-braces guard. */
document.addEventListener('DOMContentLoaded', function() {

  /* ══════════════════════════════════════
     0. CONFIG ISLAND
     All Liquid-derived data and settings are emitted by sections/map.liquid
     as JSON in <script type="application/json" id="bww-map-config">. This
     file is static (cacheable); the page carries only the data.
     ══════════════════════════════════════ */

  var cfgEl = document.getElementById('bww-map-config');
  if (!cfgEl) {
    console.warn('[BWW map] config island #bww-map-config not found — map not initialised.');
    return;
  }
  var CFG;
  try {
    CFG = JSON.parse(cfgEl.textContent);
  } catch (e) {
    console.warn('[BWW map] config island is not valid JSON — map not initialised.', e);
    return;
  }

  // Map Centre settings are text fields; parseFloat reproduces the numbers the
  // old inline script emitted raw into the source.
  var MAP_CENTER_LAT = parseFloat(CFG.mapCenterLat);
  var MAP_CENTER_LNG = parseFloat(CFG.mapCenterLng);

  /* ══════════════════════════════════════
     1. UTILITY FUNCTIONS
     ══════════════════════════════════════ */

  function waitForLeaflet(callback, maxAttempts) {
    // 200 × 100ms = 20s before declaring failure — slow connections are still
    // downloading leaflet.js at 5s, and a premature error is worse than a wait.
    maxAttempts = maxAttempts || 200;
    var attempts = 0;
    var check = setInterval(function() {
      attempts++;
      if (typeof L !== 'undefined' && L.markerClusterGroup) {
        clearInterval(check);
        callback();
      } else if (attempts >= maxAttempts) {
        clearInterval(check);
        var el = document.getElementById('venues-leaflet-map');
        if (el) el.innerHTML = '<div style="padding:20px;text-align:center;">Map loading error. Please refresh.</div>';
      }
    }, 100);
  }

  // localStorage wrappers — Safari private mode throws on setItem.
  function lsGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function lsSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) {}
  }

  var REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // One-shot detector for genuine user input on the map. DOM events only —
  // Leaflet's movestart/zoomstart also fire on programmatic flights, so they
  // can't distinguish the user from the intro flyover.
  var firstInteractionFired = false;
  var firstInteractionCallbacks = [];
  function onFirstMapInteraction(callback) {
    if (firstInteractionFired) { callback(); return; }
    if (!firstInteractionCallbacks.length) {
      var el = document.getElementById('venues-leaflet-map');
      if (el) {
        var events = ['pointerdown', 'wheel', 'touchstart', 'keydown'];
        var fire = function() {
          firstInteractionFired = true;
          events.forEach(function(ev) { el.removeEventListener(ev, fire); });
          var cbs = firstInteractionCallbacks;
          firstInteractionCallbacks = [];
          cbs.forEach(function(cb) { try { cb(); } catch (e) {} });
        };
        events.forEach(function(ev) { el.addEventListener(ev, fire, { passive: true }); });
      }
    }
    firstInteractionCallbacks.push(callback);
  }

  // Event live/later statuses run on venue time (Europe/London), not the
  // visitor's clock — a viewer in New York should see Belfast's "live now".
  function belfastNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', hour12: false
      }).formatToParts(new Date());
      var v = {};
      parts.forEach(function(p) { v[p.type] = p.value; });
      return {
        year: Number(v.year), month: Number(v.month), day: Number(v.day),
        hour: Number(v.hour) % 24, minute: Number(v.minute)
      };
    } catch (e) {
      var d = new Date();
      return { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate(), hour: d.getHours(), minute: d.getMinutes() };
    }
  }

  function getCurrentTimeHour() { return belfastNow().hour; }
  function getCurrentTimeMinutes() { return belfastNow().minute; }

  function isEventLive(endHour, endMinutes) {
    var currentTotal = getCurrentTimeHour() * 60 + getCurrentTimeMinutes();
    var endTotal = endHour * 60 + (endMinutes || 0);
    return currentTotal < endTotal;
  }

  function shouldEventBeHotNow(event) {
    var currentTotal = getCurrentTimeHour() * 60 + getCurrentTimeMinutes();
    var startTotal = event.startHour * 60 + (event.startMinutes || 0);
    var endTotal = event.endHour * 60 + (event.endMinutes || 0);
    return currentTotal >= startTotal && currentTotal < endTotal;
  }

  function shouldEventBeHotLater(event) {
    var currentTotal = getCurrentTimeHour() * 60 + getCurrentTimeMinutes();
    var startTotal = event.startHour * 60 + (event.startMinutes || 0);
    return currentTotal < startTotal;
  }

  var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  function getStreetviewUrl(venue) {
    return 'https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=' + venue.lat + ',' + venue.lng;
  }

  function calculateDistance(lat1, lon1, lat2, lon2) {
    var R = 6371e3;
    var p1 = lat1 * Math.PI / 180;
    var p2 = lat2 * Math.PI / 180;
    var dp = (lat2 - lat1) * Math.PI / 180;
    var dl = (lon2 - lon1) * Math.PI / 180;
    var a = Math.sin(dp/2) * Math.sin(dp/2) + Math.cos(p1) * Math.cos(p2) * Math.sin(dl/2) * Math.sin(dl/2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  }


  /* ══════════════════════════════════════
     2. FESTIVAL SCHEDULE DATA  (built from section settings + event products)
     ══════════════════════════════════════ */

  // Whether an events collection has been configured in the theme editor.
  var EVENTS_CONFIGURED = CFG.eventsConfigured;

  // Day skeleton — one entry per festival day, labels + ymd derived from the
  // start date. Built in Liquid, delivered via the config island.
  var festivalDays = CFG.festivalDays;

  // Map each YYYY-MM-DD to its day key so events can be filed into the right day.
  var ymdToDayKey = {};
  Object.keys(festivalDays).forEach(function(k) { ymdToDayKey[festivalDays[k].ymd] = k; });

  // Raw events emitted from the configured collection's products + variants.
  // One entry per variant (= one session). Times stay as display strings and
  // are parsed to 24h numbers in JS below.
  var rawEvents = CFG.rawEvents;

  // Products associated with each venue (from the events collection, linked via the
  // product's custom.venue metaobject reference / custom.venue_name). One entry per product.
  var venueProducts = CFG.venueProducts;

  var SELLING_FAST_THRESHOLD = CFG.sellingFastThreshold;

  // Parse a display time string ("12:30pm", "4pm", "19:00") to minutes since midnight.
  // Returns null if it can't be parsed.
  function parseTimeToMinutes(str) {
    if (!str) return null;
    var s = String(str).toLowerCase().replace(/\s+/g, '');
    var m = s.match(/^(\d{1,2})(?::(\d{2}))?(am|pm)?$/);
    if (!m) return null;
    var h = parseInt(m[1], 10);
    var min = m[2] ? parseInt(m[2], 10) : 0;
    var ap = m[3];
    if (ap === 'pm' && h < 12) h += 12;
    if (ap === 'am' && h === 12) h = 0;
    if (h > 23 || min > 59) return null;
    return h * 60 + min;
  }

  // Build a human time label from start/end ("12:30pm – 4:00pm").
  function buildTimeLabel(ev) {
    if (ev.startStr && ev.endStr) return ev.startStr + ' – ' + ev.endStr;
    if (ev.startStr) return ev.startStr;
    if (ev.endStr) return ev.endStr;
    return ev.sessionLabel || 'See details';
  }

  // Distribute raw events into their festival day, parse times, derive status.
  (function buildSchedule() {
    rawEvents.forEach(function(re) {
      var dayKey = ymdToDayKey[re.ymd];
      if (!dayKey) return; // event date falls outside the festival window — skip
      var startMin = parseTimeToMinutes(re.startStr);
      var endMin = parseTimeToMinutes(re.endStr);
      var hasTimes = startMin !== null && endMin !== null && endMin > startMin;
      var soldOut = !re.available;
      var sellingFast = !soldOut && SELLING_FAST_THRESHOLD > 0 && re.inventory >= 0 && re.inventory <= SELLING_FAST_THRESHOLD;

      var ev = {
        title: re.title,
        venue: re.venue,
        venueId: re.venueId,
        link: re.link,
        ticketUrl: re.link, // alias used by the live-events feed card renderer
        time: buildTimeLabel(re),
        startHour: hasTimes ? Math.floor(startMin / 60) : null,
        startMinutes: hasTimes ? startMin % 60 : null,
        endHour: hasTimes ? Math.floor(endMin / 60) : null,
        endMinutes: hasTimes ? endMin % 60 : null,
        hasTimes: hasTimes,
        soldOut: soldOut,
        sellingFast: sellingFast,
        status: soldOut ? 'sold_out' : (sellingFast ? 'selling_fast' : '')
      };

      var day = festivalDays[dayKey];
      day.events.push(ev);
      if (hasTimes) {
        day.baseLiveEvents.push(ev);
        day.baseHotLaterEvents.push(ev);
      }
      if (sellingFast) day.sellingFastEvents.push(ev);
      if (soldOut) day.soldOutEvents.push(ev);
    });

    // Sort each day's events by start time; timed events first, then untimed.
    Object.keys(festivalDays).forEach(function(k) {
      festivalDays[k].events.sort(function(a, b) {
        var am = a.hasTimes ? a.startHour * 60 + a.startMinutes : 24 * 60 + 1;
        var bm = b.hasTimes ? b.startHour * 60 + b.startMinutes : 24 * 60 + 1;
        return am - bm;
      });
    });
  })();


  /* ══════════════════════════════════════
     3. COMPUTE LIVE EVENT LISTS
     ══════════════════════════════════════ */

  var liveEvents = [];
  var hotLaterEvents = [];
  var sellingFastEvents = [];
  var soldOutEvents = [];

  var FESTIVAL_START = new Date(CFG.festivalStartStr + 'T00:00:00');
  var FESTIVAL_DAYS = CFG.festivalDaysCount;

  function getActualCurrentFestivalDay() {
    // Compare on Belfast calendar dates so the active day flips at Belfast midnight.
    var bn = belfastNow();
    var startMidnight = Date.UTC(FESTIVAL_START.getFullYear(), FESTIVAL_START.getMonth(), FESTIVAL_START.getDate());
    var nowMidnight = Date.UTC(bn.year, bn.month - 1, bn.day);
    var diff = Math.round((nowMidnight - startMidnight) / 86400000);
    if (diff < 0) return 'day1';
    if (diff > FESTIVAL_DAYS - 1) return 'day' + FESTIVAL_DAYS;
    return 'day' + (diff + 1);
  }

  // Return a shallow copy of an event with a runtime status stamped on it, so the
  // shared event object isn't mutated when it appears in more than one status list.
  function withStatus(e, status) {
    var c = {};
    for (var k in e) { if (Object.prototype.hasOwnProperty.call(e, k)) c[k] = e[k]; }
    c.status = status;
    return c;
  }

  function getCurrentLiveEvents() {
    var day = festivalDays[getActualCurrentFestivalDay()];
    if (!day) return [];
    return (day.baseLiveEvents || [])
      .filter(function(e) { return shouldEventBeHotNow(e); })
      .map(function(e) { return withStatus(e, 'hot_now'); });
  }

  function getCurrentHotLaterEvents() {
    var day = festivalDays[getActualCurrentFestivalDay()];
    if (!day) return [];
    return (day.baseHotLaterEvents || [])
      .filter(function(e) { return shouldEventBeHotLater(e); })
      .map(function(e) { return withStatus(e, 'hot_later'); });
  }

  function getCurrentSellingFastEvents() {
    var day = festivalDays[getActualCurrentFestivalDay()];
    return day ? (day.sellingFastEvents || []).map(function(e) { return withStatus(e, 'selling_fast'); }) : [];
  }

  function getCurrentSoldOutEvents() {
    var day = festivalDays[getActualCurrentFestivalDay()];
    return day ? (day.soldOutEvents || []).map(function(e) { return withStatus(e, 'sold_out'); }) : [];
  }

  function refreshEventStatus() {
    liveEvents = getCurrentLiveEvents();
    hotLaterEvents = getCurrentHotLaterEvents();
    sellingFastEvents = getCurrentSellingFastEvents();
    soldOutEvents = getCurrentSoldOutEvents();
    populateLiveEvents();
    addHeatEffects();
    initHotVenueTicker();
  }


  /* ══════════════════════════════════════
     4. VENUE DATA (from Metaobjects)
     ══════════════════════════════════════ */

  var venues = CFG.venues;

  // Fold duplicate venue entries into a single pin. The same venue can be
  // entered twice in the metaobjects (e.g. once as a Hotel and again as a
  // BIA Fest venue) — match on venue id or normalised name, keep the first
  // entry and merge the duplicate's features/details so no tag is lost.
  (function dedupeVenues() {
    var byKey = {};
    var deduped = [];
    venues.forEach(function(v) {
      var idKey = 'id:' + v.id;
      var nameKey = 'name:' + String(v.name || '').toLowerCase().replace(/^the\s+/, '').replace(/[^a-z0-9]/g, '');
      var existing = byKey[idKey] || byKey[nameKey];
      if (!existing) {
        byKey[idKey] = byKey[nameKey] = v;
        deduped.push(v);
        return;
      }
      (v.features || []).forEach(function(f) {
        if (existing.features.indexOf(f) === -1) existing.features.push(f);
      });
      ['description', 'link', 'address', 'mapImage', 'brandLogo'].forEach(function(field) {
        if (!existing[field] && v[field]) existing[field] = v[field];
      });
      if ((!existing.gallery || !existing.gallery.length) && v.gallery && v.gallery.length) existing.gallery = v.gallery;
    });
    venues = deduped;
  })();

  // A venue belongs to BIA Fest when a feature tag says so ("BIA Fest Venue")
  // or one of its linked event products is a BIA Fest event. Venues keep their
  // base type (hotel, restaurant…) — BIA Fest is a cross-cutting filter, so a
  // hotel that hosts BIA Fest shows in both lists without a duplicate pin.
  function isBiafestVenue(v) {
    if (Array.isArray(v.features) && v.features.some(function(f) {
      return String(f).toLowerCase().replace(/[^a-z]/g, '').indexOf('biafest') !== -1;
    })) return true;
    var vNameKey = String(v.name || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    return venueProducts.some(function(p) {
      if (!/bia\s*fest/i.test(p.title || '')) return false;
      if (p.venueId !== null && p.venueId === v.id) return true;
      return vNameKey !== '' && String(p.venueName || '').toLowerCase().replace(/[^a-z0-9]/g, '') === vNameKey;
    });
  }


  /* ══════════════════════════════════════
     5. STATE VARIABLES
     ══════════════════════════════════════ */

  var map, markerClusterGroup;
  var currentFilter = 'all';
  var isLiveMode = false;
  var userLocation = null;
  var userMarker = null;
  var watchId = null;
  var distanceLine = null;
  var distancePopup = null;
  var previousZoom = null;
  var previousCenter = null;
  var tickerInterval = null;
  var tickerIndex = 0;

  var typeColours = {
    distillery: '#cb3a27',
    hotel: '#f89f36',
    bar: '#fd79a8',
    restaurant: '#fdcb6e',
    entertainment: '#6c5ce7'
  };

  var typeIcons = {
    distillery: '\u{1F3ED}',
    hotel: '\u{1F3E8}',
    bar: '\u{1F943}',
    restaurant: '\u{1F37D}\uFE0F',
    entertainment: '\u{1F943}'
  };


  /* ══════════════════════════════════════
     6. CORE FUNCTIONS
     ══════════════════════════════════════ */

  function createCustomIcon(type) {
    var colour = typeColours[type] || '#cb3a27';
    var icon = typeIcons[type] || '\u{1F943}';
    return L.divIcon({
      className: 'custom-whiskey-marker',
      html: '<div style="width:36px;height:36px;background:' + colour + ';border:3px solid white;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:16px;box-shadow:0 3px 10px rgba(0,0,0,0.3);">' + icon + '</div>',
      iconSize: [36, 36],
      iconAnchor: [18, 18],
      popupAnchor: [0, -18]
    });
  }

  function createWhiskeyIcon(status, venueName) {
    var colour = '#cb3a27';
    var glow = '';
    if (status === 'hot_now') {
      colour = '#ff6b6b';
      glow = 'box-shadow:0 0 15px rgba(255,107,107,0.6);animation:livePulse 1.5s infinite alternate;';
    } else if (status === 'hot_later') {
      colour = '#28a745';
      glow = 'box-shadow:0 0 10px rgba(40,167,69,0.4);';
    } else if (status === 'selling_fast') {
      colour = '#ff9500';
      glow = 'box-shadow:0 0 10px rgba(255,149,0,0.4);';
    } else if (status === 'sold_out') {
      colour = '#dc3545';
    }
    return L.divIcon({
      className: 'custom-whiskey-marker',
      html: '<div style="width:36px;height:36px;background:' + colour + ';border:3px solid white;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:16px;' + glow + '">\u{1F943}</div>',
      iconSize: [36, 36],
      iconAnchor: [18, 18],
      popupAnchor: [0, -18]
    });
  }

  // Identify the Belfast Whiskey Week Expo venue.
  // Priority: explicit Expo Venue ID setting → a venue tagged with an "Expo" feature → name match.
  function findExpoVenue() {
    var expoId = parseInt(CFG.expoVenueId, 10);
    if (!isNaN(expoId)) {
      var byId = venues.find(function(v) { return v.id === expoId; });
      if (byId) return byId;
    }
    var byFeature = venues.find(function(v) {
      return Array.isArray(v.features) && v.features.some(function(f) {
        return String(f).toLowerCase().indexOf('expo') !== -1;
      });
    });
    if (byFeature) return byFeature;
    return venues.find(function(v) {
      var n = (v.name || '').toLowerCase();
      return n.indexOf('europa') !== -1 || n.indexOf('expo') !== -1;
    });
  }

  // Find a venue's Leaflet marker inside the cluster group (matched by coordinates).
  function getMarkerForVenue(venue) {
    if (!markerClusterGroup) return null;
    var found = null;
    markerClusterGroup.eachLayer(function(layer) {
      if (found) return;
      var ll = layer.getLatLng();
      if (ll && ll.lat === venue.lat && ll.lng === venue.lng) found = layer;
    });
    return found;
  }

  // Pan so a pin sits left-of-centre (leaving room for its card on the right) and zoom in a bit.
  // On phones the card opens above the pin instead, so frame the pin lower-centre.
  function focusMarkerLeft(latlng) {
    if (!latlng) return;
    var targetZoom = Math.max(map.getZoom(), 16);
    var size = map.getSize();
    var targetPx = map.project(latlng, targetZoom);
    if (size.x <= 768) {
      // Centre below the pin so it renders in the upper part of the
      // viewport, clear of the bottom-sheet venue card.
      targetPx.y += size.y * 0.20;
    } else {
      // Place the pin ~30% from the left edge and slightly above centre
      targetPx.x -= size.x * 0.20;
      targetPx.y -= size.y * 0.08;
    }
    var targetLatLng = map.unproject(targetPx, targetZoom);
    map.setView(targetLatLng, targetZoom, { animate: true, duration: 0.6 });
  }

  // Open a pin's venue card — anchored popup on desktop, bottom sheet on phones.
  function openVenueCard(marker) {
    if (!marker) return;
    if (marker.getPopup()) marker.openPopup();
    else if (marker._bwwVenue) showMobileVenueCard(marker._bwwVenue, marker);
  }

  /* ── Mobile bottom-sheet venue card ── */
  function showMobileVenueCard(venue, marker) {
    var card = document.getElementById('mobile-venue-card');
    if (!card) return;
    dismissHintChip();
    var body = card.querySelector('.mobile-venue-card__body');
    body.innerHTML = buildMiniCard(venue);
    var detailsBtn = body.querySelector('.mini-card-details');
    if (detailsBtn) detailsBtn.addEventListener('click', function() {
      hideMobileVenueCard();
      openVenueModal(venue);
    });
    var ticketsBtn = body.querySelector('.mini-card-tickets');
    if (ticketsBtn) ticketsBtn.addEventListener('click', function() {
      window.open(venue.link, '_blank');
    });
    card.classList.add('visible');
    card.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mobile-venue-card-open');
    // Frame the pin in the upper part of the viewport, above the sheet
    if (marker) focusMarkerLeft(marker.getLatLng());
  }

  function hideMobileVenueCard() {
    var card = document.getElementById('mobile-venue-card');
    if (!card || !card.classList.contains('visible')) return;
    card.classList.remove('visible');
    card.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mobile-venue-card-open');
  }

  // Zoom to a venue's pin and open its card (same result as clicking the marker).
  // On desktop, opening the popup fires the marker's own 'popupopen' handler, which
  // calls focusMarkerLeft to frame the pin — so this matches a direct click exactly.
  function highlightVenueMarker(venue) {
    var latlng = L.latLng(venue.lat, venue.lng);
    var marker = getMarkerForVenue(venue);
    if (marker && typeof markerClusterGroup.zoomToShowLayer === 'function') {
      // Un-clusters if needed, zooms in, then opens the pin's card (which frames it).
      markerClusterGroup.zoomToShowLayer(marker, function() {
        openVenueCard(marker);
      });
    } else if (marker) {
      openVenueCard(marker);
    } else {
      // Marker not currently rendered (e.g. filtered out) — just focus there
      focusMarkerLeft(latlng);
    }
  }


  // Frame all venue pins in the viewport (Default Zoom acts as the max zoom-in).
  // Falls back to the configured centre/zoom when there are no pins to frame.
  function fitAllVenues(animate) {
    if (CFG.fitVenuesOnLoad) {
      var bounds = markerClusterGroup.getBounds();
      if (bounds.isValid()) {
        map.fitBounds(bounds, { padding: [48, 48], maxZoom: CFG.defaultZoom, animate: animate !== false });
        return;
      }
    }
    map.setView([MAP_CENTER_LAT, MAP_CENTER_LNG], CFG.defaultZoom, { animate: animate !== false });
  }


  /* ── Map Initialisation ── */

  function initMap() {
    var belfastCenter = [MAP_CENTER_LAT, MAP_CENTER_LNG];

    map = L.map('venues-leaflet-map', {
      minZoom: 5,
      maxZoom: 18,
      zoomControl: false
    });

    // Land on the final framing straight away — setting the centre view first
    // and bounds-fitting 200ms later used to download two full sets of tiles.
    if (CFG.fitVenuesOnLoad) {
      var initialBounds = L.latLngBounds(venues.map(function(v) { return [v.lat, v.lng]; }));
      if (initialBounds.isValid()) {
        map.fitBounds(initialBounds, { padding: [48, 48], maxZoom: CFG.defaultZoom, animate: false });
      } else {
        map.setView(belfastCenter, CFG.defaultZoom);
      }
    } else {
      map.setView(belfastCenter, CFG.defaultZoom);
    }

    // Single fixed subdomain: one warm HTTP/2 connection (see preconnect above)
    // beats sharding tile requests across a/b/c/d hosts.
    // {r} (retina @2x tiles) only on desktop: on phones it tripled the bytes
    // of every tile over cellular — the whole reason the map felt slow on
    // mobile. Standard tiles render fine at phone sizes. Save-Data users get
    // standard tiles everywhere.
    var tileRetina = isMobile ? '' : '{r}';
    if (navigator.connection && navigator.connection.saveData) tileRetina = '';
    L.tileLayer('https://a.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}' + tileRetina + '.png', {
      attribution: '&copy; OpenStreetMap contributors &copy; CARTO',
      maxZoom: 19,
      // Don't fetch tiles mid-animation — the intro flyover crosses four zoom
      // levels and was pulling 100+ throwaway tiles (several MB) during the
      // flight. Scaled parent tiles cover the animation; fresh tiles load on
      // arrival.
      updateWhenZooming: false,
      updateWhenIdle: true
    }).addTo(map);

    markerClusterGroup = L.markerClusterGroup({
      showCoverageOnHover: false,
      zoomToBoundsOnClick: true,
      maxClusterRadius: 80,
      iconCreateFunction: function(cluster) {
        var count = cluster.getChildCount();
        // Heat scale: size, colour temperature and glow all grow with density
        var heat = count < 6 ? 'cool' : count < 15 ? 'warm' : 'hot';
        var size = count < 6 ? 40 : count < 15 ? 48 : 56;
        return new L.DivIcon({
          html: '<div class="bww-cluster-halo"></div><div class="bww-cluster-core">' + count + '</div>',
          className: 'whiskey-cluster bww-cluster bww-cluster--' + heat,
          iconSize: new L.Point(size, size)
        });
      }
    });

    addVenueMarkers(venues);
    map.addLayer(markerClusterGroup);

    // Sync zoom slider
    map.on('zoomend', function() {
      updateZoomSlider();
      updateTooltipVisibility();
    });

    initZoomSlider();
  }

  function addVenueMarkers(venueList) {
    markerClusterGroup.clearLayers();
    var phoneLayout = window.innerWidth <= 768;
    venueList.forEach(function(venue) {
      var marker = L.marker([venue.lat, venue.lng], {
        icon: createCustomIcon(venue.type)
      });
      marker._bwwVenue = venue;
      marker.bindTooltip(venue.name, {
        permanent: false,
        direction: 'top',
        offset: [0, -10],
        className: 'venue-tooltip'
      });
      if (phoneLayout) {
        // Phones get a bottom-sheet card instead of an anchored popup
        marker.on('click', function() {
          showMobileVenueCard(venue, this);
        });
      } else {
        marker.bindPopup(buildMiniCard(venue), {
          className: 'venue-mini-popup',
          maxWidth: 280,
          minWidth: 240,
          offset: [0, -10],
          autoPan: false
        });
        marker.on('popupopen', function() {
          dismissHintChip();
          // Position the clicked pin to the left & zoom in a bit, so the card has room to the right
          focusMarkerLeft(this.getLatLng());
          var popup = this.getPopup();
          var el = popup.getElement();
          if (el) {
            el.querySelector('.mini-card-details')?.addEventListener('click', function() {
              map.closePopup();
              openVenueModal(venue);
            });
            el.querySelector('.mini-card-tickets')?.addEventListener('click', function() {
              window.open(venue.link, '_blank');
            });
          }
        });
      }
      markerClusterGroup.addLayer(marker);
    });
  }

  // Venue image URLs are emitted at width=1200; swap the Shopify CDN width
  // param down to what the card actually needs. The card is ~300px wide on
  // desktop (popup) and full-width in the phone bottom sheet, but phones are
  // where load time hurts, so they get the smallest variant.
  var CARD_IMG_WIDTH = window.matchMedia('(max-width: 768px)').matches ? 400 : 600;
  function cdnSize(src, w) {
    return src ? src.replace(/([?&]width=)\d+/, '$1' + (w || CARD_IMG_WIDTH)) : src;
  }

  // Keeps the gallery dots in sync with the swiped slide. Global because the
  // carousel HTML (with its inline onscroll) is injected into both Leaflet
  // popups and the mobile bottom sheet after this script runs.
  window.bwwGalleryScroll = function(track) {
    var i = Math.round(track.scrollLeft / track.clientWidth);
    track.parentElement.querySelectorAll('.mini-card-gallery-dot').forEach(function(dot, j) {
      dot.classList.toggle('active', j === i);
    });
  };

  // Apple-Wallet-style pass: main section opens details, the perforated
  // stub opens tickets — with live event count + lowest price when available.
  function buildWalletPass(venue) {
    var products = getVenueProducts(venue).filter(function(p) { return p.available; });
    var stubMeta = '';
    if (products.length) {
      var minPrice = null, minLabel = '';
      products.forEach(function(p) {
        var n = parseFloat(String(p.price).replace(/[^0-9.]/g, ''));
        if (!isNaN(n) && (minPrice === null || n < minPrice)) { minPrice = n; minLabel = p.price; }
      });
      stubMeta = products.length + (products.length === 1 ? ' event' : ' events') +
        (minLabel ? ' · from ' + minLabel : '');
    }
    // Flat poster action row — ghost Details, solid yellow Tickets
    return '<div class="mini-card-actions">' +
      '<button class="mini-card-details">Details</button>' +
      '<button class="mini-card-tickets">Tickets' +
        (stubMeta ? '<span class="mini-card-tickets-meta">' + escapeHtml(stubMeta) + '</span>' : '') +
      '</button>' +
    '</div>';
  }

  function buildMiniCard(venue) {
    var typeBg = typeColours[venue.type] || '#cb3a27';
    var icon = typeIcons[venue.type] || '\u{1F943}';
    var featuresHtml = '';
    if (venue.features && Array.isArray(venue.features)) {
      featuresHtml = venue.features.slice(0, 3).map(function(f) {
        return '<span class="mini-tag">' + escapeHtml(f) + '</span>';
      }).join('');
    }

    // Gallery photos first, the map image always last. One image = no carousel chrome.
    var slides = (venue.gallery || []).slice();
    if (venue.mapImage) slides.push(venue.mapImage);

    var heroContent;
    if (slides.length > 1) {
      heroContent = '<div class="mini-card-gallery" onscroll="bwwGalleryScroll(this)">' +
        slides.map(function(src, i) {
          // First slide loads immediately at high priority; the rest wait until swiped near
          var loadAttrs = i === 0 ? ' fetchpriority="high" decoding="async"' : ' loading="lazy" decoding="async"';
          return '<img src="' + escapeHtml(cdnSize(src)) + '" alt="' + escapeHtml(venue.name) + '" class="mini-card-hero-img"' + loadAttrs + '>';
        }).join('') +
        '</div>' +
        '<div class="mini-card-gallery-dots">' +
        slides.map(function(_, i) {
          return '<span class="mini-card-gallery-dot' + (i === 0 ? ' active' : '') + '"></span>';
        }).join('') +
        '</div>';
    } else if (slides.length === 1) {
      heroContent = '<img src="' + escapeHtml(cdnSize(slides[0])) + '" alt="' + escapeHtml(venue.name) + '" class="mini-card-hero-img" fetchpriority="high" decoding="async">';
    } else {
      heroContent = '<div class="mini-card-hero-fallback" style="background:linear-gradient(135deg,' + typeBg + ',var(--bww-amber));">' + icon + '</div>';
    }

    return '<div class="mini-card">' +
      '<div class="mini-card-hero">' +
        heroContent +
        '<span class="mini-card-hero-badge" style="background:' + typeBg + ';">' + icon + ' ' + escapeHtml(venue.type) + '</span>' +
        '<div class="mini-card-hero-overlay">' +
          '<h4 class="mini-card-hero-name">' + escapeHtml(venue.name) + '</h4>' +
        '</div>' +
      '</div>' +
      '<div class="mini-card-body">' +
        '<p class="mini-card-address">' + escapeHtml(venue.address) + '</p>' +
        '<p class="mini-card-desc">' + escapeHtml(venue.description) + '</p>' +
        (featuresHtml ? '<div class="mini-card-tags">' + featuresHtml + '</div>' : '') +
        buildWalletPass(venue) +
        (venue.collectionUrl ? '<a href="' + escapeHtml(venue.collectionUrl) + '" class="mini-card-collection">View events &amp; tickets →</a>' : '') +
      '</div>' +
    '</div>';
  }

  function updateTooltipVisibility() {
    // Tooltips are more visible at higher zoom
    // Leaflet handles tooltip display by default
  }


  /* ── Venue Type Filtering ── */

  // Live venue counts for the legend items and mobile chips.
  // Categories with no venues are dimmed and disabled (filtering into an empty map is a dead end).
  function updateVenueCounts() {
    var counts = { all: venues.length, biafest: 0 };
    venues.forEach(function(v) {
      counts[v.type] = (counts[v.type] || 0) + 1;
      if (isBiafestVenue(v)) counts.biafest++;
    });
    document.querySelectorAll('.legend-filter-btn, .filter-btn--biafest').forEach(function(item) {
      var n = counts[item.dataset.filter] || 0;
      var span = item.querySelector('.legend-count, .chip-count');
      if (span) span.textContent = n;
      item.classList.toggle('is-empty', n === 0);
    });
    // The grid's BIA Fest button is server-rendered hidden; show it only
    // when there are venues for it.
    var gridBiafest = document.querySelector('.filter-btn--biafest');
    if (gridBiafest) gridBiafest.hidden = counts.biafest === 0;
  }

  // Zoom to the Expo venue & open its pin card (shared by the legend item and mobile chip).
  function locateExpo() {
    var expoVenue = findExpoVenue();
    if (!expoVenue) { showToast('Expo venue coming soon'); return; }
    // De-activate any active type filter so the UI reflects the EXPO selection
    document.querySelectorAll('.legend-item, .map-filter-chip').forEach(function(i) { i.classList.remove('active'); });
    var legendExpo = document.getElementById('legend-expo-btn');
    if (legendExpo) legendExpo.classList.add('active');
    var chipExpo = document.getElementById('map-chip-expo');
    if (chipExpo) chipExpo.classList.add('active');
    highlightVenueMarker(expoVenue);
  }

  // Identify the Cocktail City venue — a venue tagged 'cocktail' (feature or name).
  function findCocktailVenue() {
    var byFeature = venues.find(function(v) {
      return Array.isArray(v.features) && v.features.some(function(f) {
        return String(f).toLowerCase().indexOf('cocktail') !== -1;
      });
    });
    if (byFeature) return byFeature;
    return venues.find(function(v) {
      return (v.name || '').toLowerCase().indexOf('cocktail') !== -1;
    });
  }

  function locateCocktail() {
    var venue = findCocktailVenue();
    if (!venue) { window.location.href = '/pages/cocktail-takeover'; return; }
    document.querySelectorAll('.legend-item, .map-filter-chip').forEach(function(i) { i.classList.remove('active'); });
    var btn = document.getElementById('legend-cocktail-btn');
    if (btn) btn.classList.add('active');
    highlightVenueMarker(venue);
  }

  // Venues matching a filter key — a venue type, 'biafest' (cross-cutting
  // feature filter), or 'all'.
  function venuesMatchingFilter(filterType) {
    if (filterType === 'all') return venues;
    if (filterType === 'biafest') return venues.filter(isBiafestVenue);
    return venues.filter(function(v) { return v.type === filterType; });
  }

  function applyVenueFilter(filterType) {
    currentFilter = filterType;
    dismissHintChip();
    hideMobileVenueCard();

    document.querySelectorAll('.filter-btn').forEach(function(btn) {
      btn.classList.toggle('active', btn.dataset.filter === filterType);
    });
    document.querySelectorAll('.legend-filter-btn').forEach(function(item) {
      item.classList.toggle('active', item.dataset.filter === filterType);
    });
    // A type filter supersedes any EXPO / Cocktail City selection
    var expoLegend = document.getElementById('legend-expo-btn');
    if (expoLegend) expoLegend.classList.remove('active');
    var expoChip = document.getElementById('map-chip-expo');
    if (expoChip) expoChip.classList.remove('active');
    var cocktailLegend = document.getElementById('legend-cocktail-btn');
    if (cocktailLegend) cocktailLegend.classList.remove('active');

    var filtered = venuesMatchingFilter(filterType);
    addVenueMarkers(filtered);
    populateVenuesList();

    // Zoom to fit filtered markers
    var bounds = markerClusterGroup.getBounds();
    if (bounds.isValid()) {
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 15 });
    }
  }


  /* ── Venue Cards Grid ── */

  function populateVenuesList() {
    var list = document.getElementById('venues-list');
    if (!list) return;
    list.innerHTML = '';

    var filtered = venuesMatchingFilter(currentFilter);

    filtered.forEach(function(venue) {
      var card = document.createElement('div');
      card.className = 'venue-card ' + venue.type;

      var featuresHtml = '';
      if (venue.features && Array.isArray(venue.features)) {
        featuresHtml = venue.features.map(function(f) { return '<span class="feature-tag">' + escapeHtml(f) + '</span>'; }).join('');
      }

      var imageHtml = venue.mapImage
        ? '<img src="' + escapeHtml(cdnSize(venue.mapImage)) + '" alt="' + escapeHtml(venue.name) + '" class="venue-map-image" loading="lazy" decoding="async" data-lat="' + venue.lat + '" data-lng="' + venue.lng + '">'
        : '';

      card.innerHTML =
        '<div class="venue-header">' +
          '<div class="venue-type ' + venue.type + '">' + escapeHtml(venue.type) + '</div>' +
          '<h3 class="venue-name">' + escapeHtml(venue.name) + '</h3>' +
          '<p class="venue-address">' + escapeHtml(venue.address) + '</p>' +
        '</div>' +
        '<div class="venue-content">' +
          imageHtml +
          '<p class="venue-description">' + escapeHtml(venue.description) + '</p>' +
          '<div class="venue-features">' + featuresHtml + '</div>' +
          '<div class="venue-actions">' +
            (venue.collectionUrl ? '<a href="' + escapeHtml(venue.collectionUrl) + '" class="venue-btn primary">View Events &amp; Tickets</a>' : '') +
            '<a href="' + escapeHtml(venue.link) + '" target="_blank" rel="noopener" class="venue-btn primary">Get Tickets</a>' +
            '<a href="' + getStreetviewUrl(venue) + '" target="_blank" rel="noopener" class="venue-btn entertainment">Street View</a>' +
            '<button class="venue-btn map-btn" data-lat="' + venue.lat + '" data-lng="' + venue.lng + '">\u{1F943} Show on Map</button>' +
          '</div>' +
        '</div>';

      list.appendChild(card);
    });

    // Bind card image clicks and map buttons
    list.querySelectorAll('.venue-map-image, .venue-btn.map-btn').forEach(function(el) {
      el.addEventListener('click', function() {
        var lat = parseFloat(this.dataset.lat);
        var lng = parseFloat(this.dataset.lng);
        var venue = venues.find(function(v) { return v.lat === lat && v.lng === lng; });
        if (venue) openVenueModal(venue);
        document.querySelector('.map-container').scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }


  /* ── Live Events Feed ── */

  function populateLiveEvents() {
    var grid = document.getElementById('live-events-grid');
    if (!grid) return;

    var allEvents = [].concat(liveEvents, hotLaterEvents, sellingFastEvents, soldOutEvents);
    if (allEvents.length === 0) {
      grid.innerHTML = '<p style="text-align:center;opacity:0.7;">No live events right now. Check back during the festival!</p>';
      return;
    }

    grid.innerHTML = '';
    allEvents.forEach(function(ev) {
      var card = document.createElement('div');
      card.className = 'live-event-card ' + (ev.status || 'hot_now');
      var statusLabel = ev.status === 'hot_now' ? 'LIVE' : ev.status === 'hot_later' ? 'LATER' : ev.status === 'selling_fast' ? 'HOT' : 'SOLD OUT';

      card.innerHTML =
        '<span class="card-whiskey">\u{1F943}</span>' +
        '<span class="card-time">' + escapeHtml(ev.time) + '</span>' +
        '<h4 class="card-title">' + escapeHtml(ev.title) + '</h4>' +
        '<p class="card-venue">\u{1F4CD} ' + escapeHtml(ev.venue) + '</p>' +
        '<div class="card-actions">' +
          (ev.ticketUrl ? '<a href="' + escapeHtml(ev.ticketUrl) + '" target="_blank" rel="noopener" class="card-btn primary">Get Tickets</a>' : '') +
          (ev.venueId ? '<button class="card-btn secondary" data-venue-id="' + ev.venueId + '">Show on Map</button>' : '') +
        '</div>';

      grid.appendChild(card);
    });

    // Bind map buttons in live feed
    grid.querySelectorAll('.card-btn.secondary').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var vid = parseInt(this.dataset.venueId);
        var venue = venues.find(function(v) { return v.id === vid; });
        if (venue) {
          openVenueModal(venue);
          document.querySelector('.map-container').scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });
  }

  function addHeatEffects() {
    // Update marker icons for venues with live events
    if (!markerClusterGroup) return;
    var liveVenueIds = liveEvents.map(function(e) { return e.venueId; });
    var hotLaterVenueIds = hotLaterEvents.map(function(e) { return e.venueId; });
    var sellingFastVenueIds = sellingFastEvents.map(function(e) { return e.venueId; });

    markerClusterGroup.eachLayer(function(layer) {
      var latlng = layer.getLatLng();
      var venue = venues.find(function(v) { return v.lat === latlng.lat && v.lng === latlng.lng; });
      if (!venue) return;

      if (liveVenueIds.indexOf(venue.id) !== -1) {
        layer.setIcon(createWhiskeyIcon('hot_now', venue.name));
      } else if (hotLaterVenueIds.indexOf(venue.id) !== -1) {
        layer.setIcon(createWhiskeyIcon('hot_later', venue.name));
      } else if (sellingFastVenueIds.indexOf(venue.id) !== -1) {
        layer.setIcon(createWhiskeyIcon('selling_fast', venue.name));
      }
    });
  }


  /* ── Venue Modal ── */

  var modal = document.getElementById('venue-modal');
  var modalBody = document.getElementById('modal-body');

  function openVenueModal(venue) {
    previousZoom = map.getZoom();
    previousCenter = map.getCenter();

    map.flyTo([venue.lat, venue.lng], Math.max(map.getZoom(), 17), {
      animate: true, duration: 1.0
    });

    // Draw distance line if user location is active
    if (userLocation) drawDistanceLine(venue);

    var typeBg = typeColours[venue.type] || '#cb3a27';
    var icon = typeIcons[venue.type] || '\u{1F943}';

    var featuresHtml = '';
    if (venue.features && Array.isArray(venue.features)) {
      featuresHtml = '<div class="modal-features">' +
        venue.features.map(function(f) { return '<span class="feature-tag">' + escapeHtml(f) + '</span>'; }).join('') +
        '</div>';
    }

    // Build event sections for this venue
    var venueEventsHtml = buildVenueEventsHtml(venue);
    // Products associated with this venue (whiskey tastings, tickets, etc.)
    var venueProductsHtml = buildVenueProductsHtml(venue);

    modalBody.innerHTML =
      '<h2 class="modal-venue-name">' + icon + ' ' + escapeHtml(venue.name) + '</h2>' +
      '<p class="modal-venue-address">' + escapeHtml(venue.address) + '</p>' +
      '<span class="modal-venue-type" style="background:' + typeBg + '">' + escapeHtml(venue.type) + '</span>' +
      '<p class="modal-description">' + escapeHtml(venue.description) + '</p>' +
      featuresHtml +
      venueEventsHtml +
      venueProductsHtml +
      '<div class="modal-actions">' +
        (venue.collectionUrl ? '<a href="' + escapeHtml(venue.collectionUrl) + '" class="modal-btn primary">\u{1F39F}\uFE0F View Events &amp; Tickets</a>' : '') +
        '<a href="' + escapeHtml(venue.link) + '" target="_blank" rel="noopener" class="modal-btn primary">\u{1F39F}\uFE0F Get Tickets</a>' +
        '<button class="modal-btn invite" data-venue-name="' + escapeHtml(venue.name) + '" data-venue-link="' + escapeHtml(venue.link) + '">\u{1F91D} Invite a Mate</button>' +
        '<button class="modal-btn secondary" id="modal-back-btn">\u{1F5FA}\uFE0F Back to Map</button>' +
        '<a href="' + getStreetviewUrl(venue) + '" target="_blank" rel="noopener" class="modal-btn tertiary">\u{1F441}\uFE0F Street View</a>' +
      '</div>';

    modal.style.display = 'flex';
    modal.style.visibility = 'visible';
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';

    // Bind modal-specific actions
    var backBtn = document.getElementById('modal-back-btn');
    if (backBtn) backBtn.addEventListener('click', closeVenueModal);

    modalBody.querySelectorAll('.modal-btn.invite').forEach(function(btn) {
      btn.addEventListener('click', function() {
        inviteAMate(this.dataset.venueName, this.dataset.venueLink);
      });
    });
  }

  function buildVenueEventsHtml(venue) {
    var html = '';
    var venueLive = liveEvents.filter(function(e) { return e.venueId === venue.id; });
    var venueLater = hotLaterEvents.filter(function(e) { return e.venueId === venue.id; });
    var venueSelling = sellingFastEvents.filter(function(e) { return e.venueId === venue.id; });
    var venueSoldOut = soldOutEvents.filter(function(e) { return e.venueId === venue.id; });

    venueLive.forEach(function(ev) {
      html += '<div class="modal-events-section live-now">' +
        '<span class="modal-event-badge g1">LIVE</span>' +
        '<h4 class="modal-event-title">\u{1F534} ' + escapeHtml(ev.title) + '</h4>' +
        '<p class="modal-event-meta">\u{1F534} Live Now' + (ev.attendees ? ' \u{1F465} ' + ev.attendees + ' attending' : '') + '</p>' +
        (ev.ticketUrl ? '<a href="' + escapeHtml(ev.ticketUrl) + '" target="_blank" rel="noopener" class="btn-g g1">\u{1F680} Join Now</a>' : '') +
        '</div>';
    });

    venueLater.forEach(function(ev) {
      html += '<div class="modal-events-section coming-later">' +
        '<span class="modal-event-badge g2">Later</span>' +
        '<h4 class="modal-event-title">\u23F3 ' + escapeHtml(ev.title) + '</h4>' +
        '<p class="modal-event-meta">\u{1F552} ' + escapeHtml(ev.time) + (ev.attendees ? ' \u{1F465} ' + ev.attendees + ' interested' : '') + '</p>' +
        (ev.ticketUrl ? '<a href="' + escapeHtml(ev.ticketUrl) + '" target="_blank" rel="noopener" class="btn-g g2">\u{1F3AB} Reserve Spot</a>' : '') +
        '</div>';
    });

    venueSelling.forEach(function(ev) {
      html += '<div class="modal-events-section selling-fast">' +
        '<span class="modal-event-badge g3">Hot</span>' +
        '<h4 class="modal-event-title">\u{1F525} ' + escapeHtml(ev.title) + '</h4>' +
        (ev.ticketUrl ? '<a href="' + escapeHtml(ev.ticketUrl) + '" target="_blank" rel="noopener" class="btn-g g3">\u26A1 Buy Now</a>' : '') +
        '</div>';
    });

    venueSoldOut.forEach(function(ev) {
      html += '<div class="modal-events-section sold-out">' +
        '<span class="modal-event-badge g4">Sold Out</span>' +
        '<h4 class="modal-event-title" style="text-decoration:line-through;opacity:0.6;">' + escapeHtml(ev.title) + '</h4>' +
        '<p class="modal-event-meta">\u274C No Tickets Available</p>' +
        '</div>';
    });

    return html;
  }

  // Products associated with this venue (matched by venue id, with a name fallback).
  function getVenueProducts(venue) {
    var vname = (venue.name || '').toLowerCase();
    var matched = venueProducts.filter(function(p) {
      if (p.venueId != null && venue.id != null) return p.venueId === venue.id;
      return p.venueName && p.venueName.toLowerCase() === vname;
    });
    // De-duplicate by product URL
    var seen = {};
    return matched.filter(function(p) {
      if (!p.url || seen[p.url]) return false;
      seen[p.url] = true;
      return true;
    });
  }

  function buildVenueProductsHtml(venue) {
    var products = getVenueProducts(venue);
    if (!products.length) return '';

    var cards = products.map(function(p) {
      var media = p.image
        ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" class="modal-product-img" loading="lazy">'
        : '<div class="modal-product-img modal-product-img--fallback">\u{1F943}</div>';
      var soldOut = !p.available;
      return '<a class="modal-product-card" href="' + escapeHtml(p.url) + '"' + (soldOut ? '' : ' target="_blank" rel="noopener"') + '>' +
          media +
          '<div class="modal-product-info">' +
            '<span class="modal-product-title">' + escapeHtml(p.title) + '</span>' +
            '<span class="modal-product-price">' + (soldOut ? 'Sold out' : escapeHtml(p.price)) + '</span>' +
          '</div>' +
        '</a>';
    }).join('');

    return '<div class="modal-products">' +
        '<h3 class="modal-products-heading">\u{1F39F}️ What’s on at this venue</h3>' +
        '<div class="modal-products-grid">' + cards + '</div>' +
      '</div>';
  }

  function closeVenueModal() {
    clearDistanceLine();
    modal.classList.remove('active');
    setTimeout(function() {
      modal.style.display = 'none';
      modal.style.visibility = 'hidden';
    }, 300);
    document.body.style.overflow = '';

    if (previousZoom && previousCenter) {
      map.flyTo(previousCenter, Math.max(previousZoom - 1, 12), {
        animate: true, duration: 1.0
      });
    }
  }

  function initModal() {
    document.getElementById('modal-close').addEventListener('click', closeVenueModal);
    document.getElementById('modal-backdrop').addEventListener('click', closeVenueModal);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (modal.classList.contains('active')) closeVenueModal();
        var panel = document.getElementById('whats-on-today-panel');
        if (panel.classList.contains('active')) closeWhatsOnTodayPanel();
      }
    });
  }


  /* ── What's On Today Panel ── */

  var dayKeys = Object.keys(festivalDays);
  var currentDay = getActualCurrentFestivalDay();

  function showWhatsOnToday() {
    var panel = document.getElementById('whats-on-today-panel');
    renderDaySchedule(currentDay);
    updatePanelTimeContext();
    panel.style.display = 'flex';
    panel.style.visibility = 'visible';
    panel.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeWhatsOnTodayPanel() {
    var panel = document.getElementById('whats-on-today-panel');
    panel.classList.remove('active');
    setTimeout(function() {
      panel.style.display = 'none';
      panel.style.visibility = 'hidden';
    }, 300);
    document.body.style.overflow = '';
  }

  function renderDaySchedule(dayKey) {
    var day = festivalDays[dayKey];
    if (!day) return;

    currentDay = dayKey;
    document.getElementById('current-day-text').textContent = day.title + ' ' + day.date;

    var timeline = document.getElementById('events-timeline');
    var events = day.events || [];

    if (events.length === 0) {
      var emptyMsg = EVENTS_CONFIGURED
        ? 'No events scheduled for this day yet.'
        : 'Schedule coming soon.';
      timeline.innerHTML = '<p style="text-align:center;color:#999;padding:20px;">' + emptyMsg + '</p>';
      return;
    }

    var now = getCurrentTimeHour() * 60 + getCurrentTimeMinutes();
    var isToday = dayKey === getActualCurrentFestivalDay();

    timeline.innerHTML = '';
    events.forEach(function(ev) {
      var statusClass = '';

      // Time-based status only applies to today's timed events.
      if (isToday && ev.hasTimes) {
        var evStart = ev.startHour * 60 + (ev.startMinutes || 0);
        var evEnd = ev.endHour * 60 + (ev.endMinutes || 0);
        if (now > evEnd) statusClass = 'past';
        else if (now >= evStart && now < evEnd) statusClass = 'current';
        else statusClass = 'upcoming';
      }

      // Availability status (independent of the time-of-day status).
      if (ev.soldOut) statusClass += ' sold-out';
      else if (ev.sellingFast) statusClass += ' selling-fast';

      // Check if this event is in live events list
      var isLive = liveEvents.some(function(le) { return le.title === ev.title; });
      if (isLive) statusClass += ' live-highlighted';

      var item = document.createElement('div');
      item.className = 'timeline-event ' + statusClass.trim();
      if (ev.venueId != null) item.dataset.venueId = ev.venueId;

      var ticketBtn = ev.soldOut
        ? '<button class="timeline-btn primary disabled" disabled aria-disabled="true">Sold Out</button>'
        : (ev.link ? '<a href="' + escapeHtml(ev.link) + '" target="_blank" rel="noopener" class="timeline-btn primary">Get Tickets</a>' : '');

      item.innerHTML =
        '<div class="timeline-time">' + escapeHtml(ev.time) + '</div>' +
        '<div class="timeline-details">' +
          '<h4 class="timeline-title">' + escapeHtml(ev.title) + '</h4>' +
          (ev.venue ? '<p class="timeline-venue">\u{1F4CD} ' + escapeHtml(ev.venue) + (ev.venueId != null ? ' <span class="timeline-venue-hint">— tap to view on map</span>' : '') + '</p>' : '') +
          '<div class="timeline-actions">' +
            ticketBtn +
            '<button class="timeline-btn share" data-title="' + escapeHtml(ev.title) + '" data-link="' + escapeHtml(ev.link || '') + '">Share</button>' +
          '</div>' +
        '</div>';

      timeline.appendChild(item);
    });

    // Bind share buttons
    timeline.querySelectorAll('.timeline-btn.share').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        inviteAMate(this.dataset.title, this.dataset.link);
      });
    });

    // Tapping an event row (but not its buttons/links) flies to the venue on the map.
    timeline.querySelectorAll('.timeline-event[data-venue-id]').forEach(function(row) {
      row.classList.add('has-venue');
      row.addEventListener('click', function(e) {
        if (e.target.closest('a, button')) return; // let action controls handle their own clicks
        var vid = parseInt(this.dataset.venueId, 10);
        var venue = venues.find(function(v) { return v.id === vid; });
        if (!venue) return;
        closeWhatsOnTodayPanel();
        openVenueModal(venue);
        document.querySelector('.map-container').scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  function updatePanelTimeContext() {
    var ctx = document.getElementById('panel-time-context');
    var now = new Date();
    var hours = now.getHours();
    var period = hours < 12 ? 'morning' : hours < 17 ? 'afternoon' : 'evening';
    ctx.textContent = 'Good ' + period + '! Here\u2019s what\u2019s happening.';
  }

  function navigateDay(direction) {
    var idx = dayKeys.indexOf(currentDay);
    if (direction === 'prev' && idx > 0) renderDaySchedule(dayKeys[idx - 1]);
    else if (direction === 'next' && idx < dayKeys.length - 1) renderDaySchedule(dayKeys[idx + 1]);
  }

  function initWhatsOnTodayPanel() {
    document.getElementById('whats-on-today-btn').addEventListener('click', showWhatsOnToday);
    document.getElementById('panel-close').addEventListener('click', closeWhatsOnTodayPanel);
    document.getElementById('panel-backdrop').addEventListener('click', closeWhatsOnTodayPanel);
    document.getElementById('prev-day').addEventListener('click', function() { navigateDay('prev'); });
    document.getElementById('next-day').addEventListener('click', function() { navigateDay('next'); });
  }


  /* ── Live Mode Toggle ── */

  function toggleLiveMode() {
    isLiveMode = !isLiveMode;
    var btn = document.getElementById('live-now-btn');
    btn.classList.toggle('active', isLiveMode);

    if (isLiveMode) {
      showWhatsOnToday();
    } else {
      closeWhatsOnTodayPanel();
    }
  }


  /* ── Social Sharing ("Invite a Mate") ── */

  function inviteAMate(name, link) {
    var text = 'Hey! Want to join me at ' + name + ' during Belfast Whiskey Week? \u{1F943}\n\nCheck it out and get tickets here: ' + link;

    if (isMobile) {
      showMobileShareOptions(text);
    } else {
      if (navigator.share) {
        navigator.share({ title: 'Belfast Whiskey Week', text: text, url: link }).catch(function() {});
      } else {
        copyToClipboard(text);
      }
    }
  }

  function showMobileShareOptions(text) {
    var shareModal = document.getElementById('share-modal');
    var options = document.getElementById('share-options');
    var encoded = encodeURIComponent(text);

    options.innerHTML =
      '<button class="share-option" data-action="whatsapp"><span class="share-icon">\u{1F4AC}</span> WhatsApp</button>' +
      '<button class="share-option" data-action="sms"><span class="share-icon">\u{1F4F1}</span> Messages</button>' +
      '<button class="share-option" data-action="more"><span class="share-icon">\u{1F310}</span> More Apps</button>' +
      '<button class="share-option" data-action="copy"><span class="share-icon">\u{1F4CB}</span> Copy Text</button>';

    shareModal.classList.add('active');

    options.querySelectorAll('.share-option').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var action = this.dataset.action;
        if (action === 'whatsapp') window.open('https://wa.me/?text=' + encoded);
        else if (action === 'sms') window.open('sms:?body=' + encoded);
        else if (action === 'more' && navigator.share) navigator.share({ title: 'Belfast Whiskey Week', text: text }).catch(function() {});
        else if (action === 'copy') copyToClipboard(text);
        shareModal.classList.remove('active');
      });
    });

    document.getElementById('share-modal-backdrop').addEventListener('click', function() {
      shareModal.classList.remove('active');
    });
  }

  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function() { showToast('Copied! Now paste to share \u{1F943}'); });
    } else {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      showToast('Copied! Now paste to share \u{1F943}');
    }
  }

  function showToast(message) {
    var toast = document.createElement('div');
    toast.className = 'share-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    setTimeout(function() { toast.remove(); }, 2100);
  }


  /* ── Geolocation & Distance ── */

  // Always defined; the location buttons only render (and are only wired up)
  // when the "Enable Find My Location" setting is on — see CFG.enableGeolocation.
  function startLocationTracking() {
    var btn = document.getElementById('location-btn');
    if (!btn) return;

    if (watchId !== null) {
      // Toggle off
      navigator.geolocation.clearWatch(watchId);
      watchId = null;
      if (userMarker) { map.removeLayer(userMarker); userMarker = null; }
      btn.classList.remove('active', 'loading');
      return;
    }

    if (!navigator.geolocation) {
      showToast('Geolocation not supported');
      return;
    }

    btn.classList.add('loading');

    watchId = navigator.geolocation.watchPosition(
      function(pos) {
        btn.classList.remove('loading');
        btn.classList.add('active');
        userLocation = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        showUserLocation();
      },
      function() {
        btn.classList.remove('loading');
        showToast('Could not get your location');
      },
      { enableHighAccuracy: true, maximumAge: 30000, timeout: 10000 }
    );
  }

  function showUserLocation() {
    if (!userLocation) return;

    var icon = L.divIcon({
      className: 'user-location-marker',
      html: '<div style="width:20px;height:20px;background:#f84846;border:3px solid #fff;border-radius:50%;box-shadow:0 0 0 3px rgba(248,72,70,0.3);"></div>',
      iconSize: [20, 20],
      iconAnchor: [10, 10]
    });

    if (userMarker) {
      userMarker.setLatLng([userLocation.lat, userLocation.lng]);
    } else {
      userMarker = L.marker([userLocation.lat, userLocation.lng], { icon: icon }).addTo(map);

      // Build nearest venues popup
      var nearest = venues.map(function(v) {
        return { venue: v, dist: calculateDistance(userLocation.lat, userLocation.lng, v.lat, v.lng) };
      }).sort(function(a, b) { return a.dist - b.dist; }).slice(0, 3);

      var popupHtml = '<div style="font-size:13px;"><strong>\u{1F4CD} You are here</strong><br><br><strong>Nearest venues:</strong><ul style="padding-left:16px;margin:4px 0;">';
      nearest.forEach(function(n) {
        var distText = n.dist < 1000 ? Math.round(n.dist) + 'm' : (n.dist / 1000).toFixed(1) + 'km';
        popupHtml += '<li>' + escapeHtml(n.venue.name) + ' (' + distText + ')</li>';
      });
      popupHtml += '</ul></div>';

      userMarker.bindPopup(popupHtml).openPopup();
      map.setView([userLocation.lat, userLocation.lng], 15);
    }
  }

  function drawDistanceLine(venue) {
    clearDistanceLine();
    if (!userLocation) return;

    var dist = calculateDistance(userLocation.lat, userLocation.lng, venue.lat, venue.lng);
    var distText = dist < 1000 ? Math.round(dist) + 'm' : (dist / 1000).toFixed(1) + 'km';
    var walkMins = Math.round(dist / 1000 * 12);

    distanceLine = L.polyline(
      [[userLocation.lat, userLocation.lng], [venue.lat, venue.lng]],
      { color: '#cb3a27', weight: 3, dashArray: '10,10', opacity: 0.7 }
    ).addTo(map);

    var midLat = (userLocation.lat + venue.lat) / 2;
    var midLng = (userLocation.lng + venue.lng) / 2;
    distancePopup = L.popup({ closeButton: false, className: 'distance-popup', offset: [0, -10] })
      .setLatLng([midLat, midLng])
      .setContent('<div style="text-align:center;font-weight:700;font-size:13px;">' + distText + '<br>~' + walkMins + ' min walk</div>')
      .openOn(map);
  }

  function clearDistanceLine() {
    if (distanceLine) { map.removeLayer(distanceLine); distanceLine = null; }
    if (distancePopup) { map.closePopup(distancePopup); distancePopup = null; }
  }


  /* ── Zoom Slider ── */

  function initZoomSlider() {
    var track = document.getElementById('zoom-slider-track');
    var handle = document.getElementById('zoom-slider-handle');
    var fill = document.getElementById('zoom-slider-fill');
    if (!track || !handle) return;

    var minZ = 5, maxZ = 18;
    var dragging = false;

    function zoomToPercent(z) { return ((z - minZ) / (maxZ - minZ)) * 100; }
    function percentToZoom(p) { return Math.round(minZ + (p / 100) * (maxZ - minZ)); }

    function setSliderPosition(percent) {
      percent = Math.max(0, Math.min(100, percent));
      handle.style.left = percent + '%';
      fill.style.width = percent + '%';
    }

    function handleMove(clientX) {
      var rect = track.getBoundingClientRect();
      var percent = ((clientX - rect.left) / rect.width) * 100;
      percent = Math.max(0, Math.min(100, percent));
      setSliderPosition(percent);
      map.setZoom(percentToZoom(percent));
    }

    // Mouse events
    handle.addEventListener('mousedown', function(e) { dragging = true; e.preventDefault(); });
    document.addEventListener('mousemove', function(e) { if (dragging) handleMove(e.clientX); });
    document.addEventListener('mouseup', function() { dragging = false; });

    // Touch events
    handle.addEventListener('touchstart', function(e) { dragging = true; e.preventDefault(); }, { passive: false });
    document.addEventListener('touchmove', function(e) { if (dragging) handleMove(e.touches[0].clientX); }, { passive: false });
    document.addEventListener('touchend', function() { dragging = false; });

    // Click on track
    track.addEventListener('click', function(e) { handleMove(e.clientX); });

    // Initial position
    updateZoomSlider();

    // Make updateZoomSlider accessible
    window._updateZoomSlider = function() {
      setSliderPosition(zoomToPercent(map.getZoom()));
    };
  }

  function updateZoomSlider() {
    if (window._updateZoomSlider) window._updateZoomSlider();
  }


  /* ── Fullscreen ── */

  function initFullscreen() {
    var btn = document.getElementById('fullscreen-btn');
    if (!btn) return;

    btn.addEventListener('click', function() {
      var container = document.querySelector('.map-container');
      if (document.fullscreenElement || document.webkitFullscreenElement) {
        (document.exitFullscreen || document.webkitExitFullscreen).call(document);
      } else {
        (container.requestFullscreen || container.webkitRequestFullscreen).call(container);
      }
    });

    document.addEventListener('fullscreenchange', function() {
      setTimeout(function() { map.invalidateSize(); }, 100);
    });
    document.addEventListener('webkitfullscreenchange', function() {
      setTimeout(function() { map.invalidateSize(); }, 100);
    });
  }


  /* ── Auto-Rotate (9PM) ── */

  // Always defined; only called when the "Enable 9PM Auto-Rotate" setting is
  // on — see the CFG.enableAutoRotate guard in the initialisation below.
  function initAutoRotate() {
    var targetId = parseInt(CFG.autoRotateVenueId);

    function checkTimeAndRotate() {
      var now = belfastNow();
      if (now.hour === 21 && now.minute === 0) {
        var target = venues.find(function(v) { return v.id === targetId; });
        if (target) {
          map.flyTo([target.lat, target.lng], 17, { duration: 3, easeLinearity: 0.1 });
          setTimeout(function() { openVenueModal(target); }, 3500);
        }
      }
    }

    var autoRotateTimer = setInterval(checkTimeAndRotate, 60000);
    document.addEventListener('shopify:section:unload', function () {
      clearInterval(autoRotateTimer);
    });
    checkTimeAndRotate();
  }


  /* ── Hot Venue Ticker ── */

  function initHotVenueTicker() {
    var ticker = document.getElementById('hot-venue-ticker');
    var tickerText = document.getElementById('ticker-text');
    if (!ticker || !tickerText) return;

    var allEvents = [].concat(liveEvents, hotLaterEvents, sellingFastEvents, soldOutEvents);
    if (allEvents.length === 0) {
      ticker.style.display = 'none';
      if (tickerInterval) { clearInterval(tickerInterval); tickerInterval = null; }
      return;
    }

    ticker.style.display = 'block';
    tickerIndex = 0;

    function showTickerEvent() {
      if (allEvents.length === 0) return;
      var ev = allEvents[tickerIndex % allEvents.length];
      var statusEmoji = ev.status === 'hot_now' ? '\u{1F534}' : ev.status === 'hot_later' ? '\u{1F7E2}' : ev.status === 'selling_fast' ? '\u{1F525}' : '\u274C';

      tickerText.textContent = statusEmoji + ' ' + ev.title + ' @ ' + ev.venue;

      // Background colour based on status
      var bg = 'rgba(203,58,39,0.95)';
      if (ev.status === 'hot_later') bg = 'rgba(40,167,69,0.95)';
      else if (ev.status === 'selling_fast') bg = 'rgba(248,159,54,0.95)';
      else if (ev.status === 'sold_out') bg = 'rgba(220,53,69,0.95)';
      ticker.style.background = bg;

      tickerIndex++;
    }

    showTickerEvent();
    if (tickerInterval) clearInterval(tickerInterval);
    tickerInterval = setInterval(showTickerEvent, 6000);

    // Click to open venue
    ticker.onclick = function() {
      var ev = allEvents[(tickerIndex - 1) % allEvents.length];
      if (ev && ev.venueId) {
        var venue = venues.find(function(v) { return v.id === ev.venueId; });
        if (venue) openVenueModal(venue);
      }
    };
  }


  /* ══════════════════════════════════════
     6b. FIRST-VISIT EXPERIENCE
     ══════════════════════════════════════ */

  /* ── Tap-Hint Chip ── */
  // Small floating "tap a venue" nudge. Shows on a visitor's first two visits,
  // dismisses permanently on their first map interaction.
  var hintChipEl = null;

  function dismissHintChip() {
    if (!hintChipEl) return;
    hintChipEl.classList.add('dismissed');
    hintChipEl.classList.remove('visible');
  }

  function initHintChip(delayMs) {
    hintChipEl = document.getElementById('map-hint-chip');
    if (!hintChipEl) return;
    var views = parseInt(lsGet('bww_map_hint_views') || '0', 10);
    if (views >= 2) { hintChipEl = null; return; }
    lsSet('bww_map_hint_views', String(views + 1));
    setTimeout(function() {
      if (hintChipEl && !hintChipEl.classList.contains('dismissed')) {
        hintChipEl.classList.add('visible');
      }
    }, delayMs || 0);
    onFirstMapInteraction(dismissHintChip);
    hintChipEl.addEventListener('click', dismissHintChip);
  }

  /* ── Intro Flyover ── */
  // On a visitor's very first visit, fly to the hero venue, pulse its pin and
  // open its mini-card briefly — demonstrating that pins are tappable. Cancels
  // the instant the user interacts; never repeats (localStorage flag).

  function findHeroVenue() {
    var nameMatch = CFG.introHeroVenue.toLowerCase().trim();
    if (nameMatch) {
      var byName = venues.find(function(v) {
        return (v.name || '').toLowerCase().indexOf(nameMatch) !== -1;
      });
      if (byName) return byName;
    }
    return findExpoVenue() || venues[0] || null;
  }

  // Returns true if the intro started (onDone fires when it completes or is
  // cancelled); false if skipped entirely.
  function runIntroFlyover(onDone) {
    if (!CFG.enableIntroFlyover) return false;
    if (REDUCED_MOTION) return false;
    if (lsGet('bww_map_intro_seen')) return false;
    var hero = findHeroVenue();
    if (!hero) return false;
    lsSet('bww_map_intro_seen', '1'); // set up-front: a mid-intro reload must not replay

    var cancelled = false;
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      if (typeof onDone === 'function') onDone();
    }
    function clearPulse() {
      var marker = getMarkerForVenue(hero);
      var el = marker && marker.getElement ? marker.getElement() : null;
      if (el) el.classList.remove('marker-intro-pulse');
    }
    onFirstMapInteraction(function() {
      if (finished) return;
      cancelled = true;
      map.stop();
      clearPulse();
      finish();
    });

    setTimeout(function() {
      if (cancelled) return;
      map.flyTo([hero.lat, hero.lng], 16, { duration: 2.2, easeLinearity: 0.25 });
      // Fixed delay rather than 'moveend' — flyTo to an unchanged view may not move at all
      setTimeout(function() {
        if (cancelled) { finish(); return; }
        var marker = getMarkerForVenue(hero);
        if (!marker) { finish(); return; }
        var openHero = function() {
          if (cancelled) { finish(); return; }
          var el = marker.getElement ? marker.getElement() : null;
          if (el) el.classList.add('marker-intro-pulse');
          openVenueCard(marker);
          // Ease back out after a beat unless the user has taken over
          setTimeout(function() {
            clearPulse();
            if (cancelled) { finish(); return; }
            if (marker.isPopupOpen && marker.isPopupOpen()) map.closePopup();
            hideMobileVenueCard();
            fitAllVenues();
            finish();
          }, 7000);
        };
        if (typeof markerClusterGroup.zoomToShowLayer === 'function') {
          markerClusterGroup.zoomToShowLayer(marker, openHero);
        } else {
          openHero();
        }
      }, 2500);
    }, 1400);
    return true;
  }


  /* ══════════════════════════════════════
     7. INITIALISATION
     ══════════════════════════════════════ */

  waitForLeaflet(function() {
    try {
      initMap();
      // Ensure map renders correctly in full-width container, then frame the pins
      setTimeout(function() {
        map.invalidateSize();
        fitAllVenues(false);
      }, 200);
      populateVenuesList();
      refreshEventStatus();

      // Start 60-second event refresh
      var statusRefreshTimer = setInterval(refreshEventStatus, 60000);
      document.addEventListener('shopify:section:unload', function () {
        clearInterval(statusRefreshTimer);
      });

      initFullscreen();
      if (CFG.enableAutoRotate) initAutoRotate();
      initHotVenueTicker();
      initModal();
      initWhatsOnTodayPanel();

      // Live Now button
      document.getElementById('live-now-btn').addEventListener('click', toggleLiveMode);

      // All Venues button
      var allBtn = document.getElementById('all-venues-btn');
      if (allBtn) {
        allBtn.addEventListener('click', function() {
          applyVenueFilter('all');
          var bounds = markerClusterGroup.getBounds();
          if (bounds.isValid()) map.fitBounds(bounds, { padding: [30, 30] });
        });
      }

      // Location button
      if (CFG.enableGeolocation) {
        var locBtn = document.getElementById('location-btn');
        if (locBtn) locBtn.addEventListener('click', startLocationTracking);
      }

      // Filter button listeners
      document.querySelectorAll('.filter-btn').forEach(function(btn) {
        btn.addEventListener('click', function() { applyVenueFilter(this.dataset.filter); });
      });
      document.querySelectorAll('.legend-filter-btn').forEach(function(item) {
        item.addEventListener('click', function() { applyVenueFilter(this.dataset.filter); });
      });

      // EXPO 2026 legend item & mobile chip — zoom to the Expo venue & open its pin card
      var expoBtn = document.getElementById('legend-expo-btn');
      if (expoBtn) expoBtn.addEventListener('click', locateExpo);
      var expoChip = document.getElementById('map-chip-expo');
      if (expoChip) expoChip.addEventListener('click', locateExpo);
      var cocktailBtn = document.getElementById('legend-cocktail-btn');
      if (cocktailBtn) cocktailBtn.addEventListener('click', locateCocktail);

      // The legend items are divs with role="button" — make Enter/Space
      // activate them like real buttons for keyboard users.
      document.querySelectorAll('.legend-item[role="button"]').forEach(function(item) {
        item.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            item.click();
          }
        });
      });

      // Map navigation dock — switcher-styled tiles that drive map elements
      var navExpo = document.getElementById('map-nav-expo');
      if (navExpo) navExpo.addEventListener('click', locateExpo);
      var navWhatsOn = document.getElementById('map-nav-whatson');
      if (navWhatsOn) navWhatsOn.addEventListener('click', function() { showWhatsOnToday(); });
      var navLive = document.getElementById('map-nav-live');
      if (navLive) navLive.addEventListener('click', function() {
        toggleLiveMode();
        this.classList.toggle('is-on', isLiveMode);
      });
      if (CFG.enableGeolocation) {
        var navNearMe = document.getElementById('map-nav-nearme');
        if (navNearMe) navNearMe.addEventListener('click', startLocationTracking);
      }
      // Mobile bottom-sheet venue card: close button + tap-on-map dismissal
      var mobileCardClose = document.querySelector('.mobile-venue-card__close');
      if (mobileCardClose) mobileCardClose.addEventListener('click', hideMobileVenueCard);
      map.on('click', hideMobileVenueCard);

      var mapNav = document.getElementById('bww-map-nav');
      if (mapNav) {
        // Move to <body> so the section's stacking context can't trap it,
        // then reuse the sitewide drag behaviour (desktop only) exactly like
        // the festival switcher it replaces on this page.
        document.body.appendChild(mapNav);
        if (window.bwwMakeDraggable) {
          window.bwwMakeDraggable(mapNav, {
            minWidthQuery: '(min-width: 769px)',
            defaultCorner: 'bottom-left',
            dragHandleOnly: true,
            deferInitialPosition: true
          });
        }
      }

      // Venue counts in the legend and mobile chips
      updateVenueCounts();

      // Deep link: /pages/map?filter=biafest (or any type key) opens the map
      // pre-filtered — used by sub-brand pages to show "their" venues.
      var urlFilter = new URLSearchParams(window.location.search).get('filter');
      if (urlFilter && venuesMatchingFilter(urlFilter).length && urlFilter !== 'all') {
        applyVenueFilter(urlFilter);
      }

      // First-visit experience: intro flyover, then the tap-hint chip.
      // Never simultaneous — the hint waits for the intro to finish or cancel.
      var startHintChip = function() { initHintChip(1200); };
      if (!runIntroFlyover(startHintChip)) startHintChip();

    } catch (error) {
      var el = document.getElementById('venues-leaflet-map');
      if (el) el.innerHTML = '<div style="padding:20px;text-align:center;">Map loading error. Please refresh.</div>';
    }
  });

});
